import { useDispatch, useSelector } from "react-redux";
import { getCars } from "../../reduxStore/entities/userCars";
import { useEffect } from "react";
import CircledImage from "../../../SharedComponents/components/ImageComponents/CircledImage";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { useNavigate } from "react-router-dom";

const UserCarsList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentPathname = window.location.pathname;

    const fetchedUserCarsState = useSelector((state) => state.userCars.cars);
    const isLoaded = useSelector((state) => state.userCars.dataLoaded);

    useEffect(() => {
        dispatch(getCars());
    }, []);


    if (!isLoaded) {
        return null;
    };



    const GetUserCarListItem = (userCar, index, navigateHref) => {
        const handleOnClick = () => {
            navigate(navigateHref);
        };

        const getCarImageUrl = () => {
            let imgUrl = "";

            if (userCar?.UserCarImages[0]?.small_car_image_url) {
                imgUrl = userCar.UserCarImages[0].small_car_image_url;
            };

            return imgUrl;
        };


        return (
            <div
                key={index}
                style={styles.userCarContainer}
                onClick={() => handleOnClick()}
            >
                <CircledImage source={getCarImageUrl()} />

                <p style={styles.userCarText}>
                    {userCar.title}
                </p>
            </div>
        );
    };

    const GetSelectedUserCarListItem = (userCar, index) => {
        const getCarImageUrl = () => {
            let imgUrl = "";

            if (userCar?.UserCarImages[0]?.small_car_image_url) {
                imgUrl = userCar.UserCarImages[0].small_car_image_url;
            };

            return imgUrl;
        };

        return (
            <div
                key={index}
                style={styles.userCarContainerHighlighted}
            >
                <CircledImage source={getCarImageUrl()} />

                <p style={styles.userCarTextHighlighted}>
                    {userCar.title}
                </p>
            </div>
        );
    };


    const GetProperUserCarListItem = (userCar, index) => {
        const navigateHref = `/garage/${userCar.user_car_id}`;

        if (currentPathname === navigateHref) {
            return GetSelectedUserCarListItem(userCar, index);
        }

        else {
            return GetUserCarListItem(userCar, index, navigateHref);
        };
    };


    return (
        <div style={styles.mainContainer}>
            {fetchedUserCarsState.map((userCar, index) => {
                return GetProperUserCarListItem(userCar, index);
            })}
        </div>
    );
};

export default UserCarsList;


const styles = {
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 20
    },
    userCarContainer: {
        display: "flex",
        alignItems: 'center',
        gap: 10,
        cursor: "pointer"
    },
    userCarText: {
        color: "#FFFFFF",
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 400
    },
    userCarContainerHighlighted: {
        display: "flex",
        alignItems: 'center',
        gap: 10,
        cursor: "pointer",
        border: "1px solid rgb(148, 191, 254)",
        borderRadius: 8
    },
    userCarTextHighlighted: {
        color: "rgb(211, 226, 5)",
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 400
    },
};